import Select from "shared/components/Form/Select";
import {
  getDate,
  getMonths,
  getYearByKey,
  getYears,
} from "shared/helpers/date";
import { Trans, useTranslation } from "react-i18next";
import React, { ChangeEvent, useState } from "react";
import { SecondStepProps } from "shared/components/Auth/RegistrationFormRedesign/types";
import cn from "classnames";
import InputGlobal from "shared/components/Form/InputGlobal";
import { simplyClick } from "shared/helpers/analytics";
import { ReactComponent as EyeIcon } from "assets/shared/img/eye.svg";
import { ReactComponent as EyeIconHide } from "assets/shared/img/eye-hide.svg";
import { CheckBox } from "shared/components/Form/CheckBox";
import { OPTION_DISABLED, OPTION_ENABLED } from "shared/constants/options";
import { ERROR_EMAIL_ALREADY_USED, termsLinks } from "shared/constants/auth";
import { Tooltip } from "shared/common-ui/Tooltip";

const SecondStep = ({
  errorDay,
  errorMonth,
  errorYear,
  errorDate,
  errorName,
  passwordError,
  setData,
  termsError,
  emailError,
  setErrorDate,
  setErrorDay,
  setErrorYear,
  setErrorMonth,
  setErrorName,
  setEmailError,
  setPasswordError,
  setTermsError,
  setCheckBox,
  data,
  checkBox,
}: SecondStepProps) => {
  const { t } = useTranslation("auth");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showTooltip, setShowTooltip] = useState<{
    name: boolean;
    email: boolean;
    password: boolean;
  }>({
    name: false,
    email: false,
    password: false,
  });

  /**
   * Handler for change Month
   */
  const handleChangeMonth = (value: string) => {
    const numValue = Number(value);
    setErrorDate("");
    setErrorMonth(false);
    setData((prev) => ({ ...prev, month: numValue }));
  };

  /**
   * Handler for change Day
   */
  const handleChangeDay = (value: string) => {
    const numValue = Number(value);
    setErrorDate("");
    setErrorDay(false);
    setData((prev) => ({ ...prev, day: numValue }));
  };

  /**
   * Handler for change Year
   */
  const handleChangeYear = (value: string) => {
    const numValue = Number(value);
    setErrorDate("");
    setErrorYear(false);
    setData((prev) => ({ ...prev, year: getYearByKey(numValue) }));
  };

  /**
   * Handler for change UserName
   */
  const handleChangeName = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setErrorName("");
    setData((prev) => ({ ...prev, first_name: value }));
  };

  /**
   * Handler for change UserEmail
   */
  const handleChangeEmail = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setEmailError("");
    setData((prev) => ({ ...prev, email: value }));
  };

  /**
   * Handler for change UserPassword
   */
  const handleSetPassword = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setPasswordError("");
    setData((prev) => ({ ...prev, password: value }));
  };

  /**
   *   Toggle show password value
   */
  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  /**
   *   Toggle terms checkbox
   */
  const handleCheckBox = () => {
    setTermsError("");
    setCheckBox((prev) => !prev);
    !checkBox && simplyClick("cl_home_p_sign_up_2_checkbox_mark");
  };

  const handleGetEmailParams = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const email = data?.email;

    if (email) {
      window.location.href = `/login/?email=${encodeURIComponent(email)}`;
    }
  };

  return (
    <>
      <span className="label_global">{t("birthdayLabel")}</span>
      <div className="birthday__wrap">
        <Select
          className={cn({ error__register: errorMonth })}
          customClassList="date_item"
          values={getMonths()}
          // @ts-expect-error: It is necessary to correctly define the value type
          value={getMonths()[data?.month] ?? ""}
          handleChange={handleChangeMonth}
          name="month"
          placeholder={t("monthPlaceholder") ?? ""}
          error={errorMonth}
          onFocus={() => {
            simplyClick("cl_home_p_sign_up_2_birthday_mo");
          }}
        />

        <Select
          className={cn({ error__register: errorDay })}
          customClassList="date_item"
          values={getDate()}
          // @ts-expect-error: It is necessary to correctly define the value type
          value={getDate()[data?.day] ?? ""}
          handleChange={handleChangeDay}
          name="day"
          placeholder={t("dayPlaceholder")}
          error={errorDay}
          onFocus={() => {
            simplyClick("cl_home_p_sign_up_2_birthday_day");
          }}
        />

        <Select
          className={cn({ error__register: errorYear })}
          customClassList="date_item"
          values={getYears()}
          // @ts-expect-error: It is necessary to correctly define the value type
          value={data?.year ?? ""}
          handleChange={handleChangeYear}
          name="year"
          placeholder={t("yearPlaceholder")}
          error={errorYear}
          onFocus={() => {
            simplyClick("cl_home_p_sign_up_2_birthday_year");
          }}
        />
      </div>
      {errorDate && <p className="error__redesign">{errorDate}</p>}

      <Tooltip
        content={<div>{t("tooltip.name")}</div>}
        isOpen={showTooltip.name}
        classNameTrigger={"redesign__tooltip"}
        placement={"top"}
        appendTo={"parent"}
      >
        <InputGlobal
          className={cn("register__redesign", { error__redesign: errorName })}
          handleChange={(e) => handleChangeName(e)}
          name="name"
          value={data.first_name}
          placeholder={t("redesignRegisterForm.namePlaceholder")}
          onFocus={() => {
            simplyClick("cl_home_p_sign_up_2_name_type");
            setShowTooltip((prev) => ({ ...prev, name: true }));
          }}
          onBlur={() => setShowTooltip((prev) => ({ ...prev, name: false }))}
        />
      </Tooltip>
      {errorName && <p className="error__redesign">{errorName}</p>}

      <Tooltip
        content={<div>{t("tooltip.email")}</div>}
        isOpen={showTooltip.email}
        classNameTrigger={"redesign__tooltip"}
        placement={"top"}
        appendTo={"parent"}
      >
        <InputGlobal
          className={cn("register__redesign", { error__redesign: emailError })}
          handleChange={(e) => handleChangeEmail(e)}
          name="email"
          value={data.email}
          placeholder={t("redesignRegisterForm.emailPlaceholder")}
          onFocus={() => {
            simplyClick("cl_home_p_sign_up_2_email_type");
            setShowTooltip((prev) => ({ ...prev, email: true }));
          }}
          onBlur={() => setShowTooltip((prev) => ({ ...prev, email: false }))}
        />
      </Tooltip>

      {emailError && <p className="error__redesign">{emailError}</p>}
      <Tooltip
        content={<div>{t("tooltip.password")}</div>}
        isOpen={showTooltip.password}
        classNameTrigger={"redesign__tooltip"}
        placement={"top"}
        appendTo={"parent"}
      >
        <InputGlobal
          className={cn("register__redesign", {
            error__redesign: passwordError,
          })}
          handleChange={(e) => handleSetPassword(e)}
          name="change-password"
          type={showPassword ? "text" : "password"}
          value={data.password}
          placeholder={t("redesignRegisterForm.passwordPlaceholder")}
          rightIconSrc={showPassword ? <EyeIconHide /> : <EyeIcon />}
          handleClickRightIcon={toggleShowPassword}
          passwordShowIcon={showPassword}
          onFocus={() => {
            simplyClick("cl_home_p_sign_up_2_pass_type");
            setShowTooltip((prev) => ({ ...prev, password: true }));
          }}
          onBlur={() =>
            setShowTooltip((prev) => ({ ...prev, password: false }))
          }
        />
      </Tooltip>

      {passwordError && <p className="error__redesign">{passwordError}</p>}

      {import.meta.env.VITE_APP_REG_ADDITIONAL_INFO && (
        <div className="confirm__text">
          {t("common:registerFormText2", {
            brandName: import.meta.env.VITE_APP_MULTI_SITE_BRAND_NAME,
          })}
        </div>
      )}

      <div className="terms__wrap">
        <CheckBox
          handleChange={handleCheckBox}
          name="is_terms"
          value={checkBox ? OPTION_ENABLED : OPTION_DISABLED}
          checkedValue={OPTION_ENABLED}
          isError={!!termsError}
          className={"redesign__checkbox"}
        />

        <div className="terms_text">
          <p>{t("termsOfUseRedesign.text")}</p>
          {termsLinks.map(({ key, href }) => (
            <React.Fragment key={key}>
              <Trans
                key={key}
                t={t}
                i18nKey={`termsOfUseRedesign.${key}`}
                components={[
                  <a target="_blank" rel="noreferrer" href={href} key="a">
                    <i aria-hidden="true"></i>
                  </a>,
                ]}
              />
              {key === "link4" && (
                <p className="ampersand">&nbsp;&amp;&nbsp;</p>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
      {termsError && <p className="error__redesign terms">{termsError}</p>}

      {emailError === ERROR_EMAIL_ALREADY_USED && (
        <div className="extra-info">
          <p>
            <a
              href="/login/"
              id="login-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleGetEmailParams}
            >
              Log in
            </a>{" "}
            or use a different one.
          </p>
        </div>
      )}
    </>
  );
};

export default SecondStep;
